// Auswahlkästchen für Sammelaktionen (Handoff Rechnungen §4): 22 px, Radius 7, gewählt = Akzentfläche + Haken.
// Eigener Knopf, damit der Klick nicht die Zeile/Karte öffnet; auf Touch-Geräten 44 px Tippfläche.
import { Check } from '@phosphor-icons/react';

export function AuswahlKaestchen({ an, onUmschalten, label, tip, gesperrt = false, groesse = 22, touch = false }: {
  an: boolean; onUmschalten: () => void; label: string; tip?: string; gesperrt?: boolean; groesse?: number; touch?: boolean;
}) {
  const flaeche = touch ? 44 : groesse;
  return (
    <button type="button" role="checkbox" aria-checked={an} aria-label={label} data-tip={tip} disabled={gesperrt}
      onClick={(e) => { e.stopPropagation(); if (!gesperrt) onUmschalten(); }}
      className="inline-flex shrink-0 items-center justify-center"
      style={{ width: flaeche, height: flaeche, margin: touch ? -(44 - groesse) / 2 : 0, padding: 0, border: 'none', background: 'transparent',
        cursor: gesperrt ? 'not-allowed' : 'pointer', opacity: gesperrt ? 0.4 : 1 }}>
      <span aria-hidden className="inline-flex items-center justify-center"
        style={{ width: groesse, height: groesse, borderRadius: Math.round(groesse / 3), background: an ? 'var(--acc-fill)' : 'transparent',
          boxShadow: an ? 'none' : 'inset 0 0 0 2px var(--fill3)', color: 'var(--acc-ink)' }}>
        {an && <Check size={12} weight="bold" />}
      </span>
    </button>
  );
}
